const constants = {
    MESSAGE_SHOW_TIME: 2000
}

export default constants;